{
  "title": "Line of Credit",
  "status": {
    "active": "Active",
    "frozen": "Frozen",
    "closed": "Closed",
    "inactive": "Inactive"
  },
  "metrics": {
    "creditLimit": "Credit Limit",
    "currentBalance": "Current Balance",
    "availableCredit": "Available Credit",
    "interestRate": "Interest Rate (APR)",
    "interestPaidYtd": "Interest Paid (YTD)"
  },
  "messages": {
    "loadingData": "Loading Line of Credit data...",
    "featureUnavailable": "Line of Credit Feature Temporarily Unavailable",
    "featureUnavailableDesc": "Line of Credit draws are currently disabled. Your debt repayment continues automatically through daily profit allocation.",
    "notEligible": "Not Yet Eligible",
    "notEligibleDesc": "You need to reach 3× your initial principal to activate Line of Credit draws.",
    "eligible": "You are eligible for a line of credit",
    "pendingRequest": "Pending Draw Request",
    "pendingRequestDesc": "Your request is being reviewed by an administrator.",
    "termsAccepted": "Line of Credit terms accepted successfully! Your credit line is now active.",
    "mustAcceptTerms": "You must accept Line of Credit terms first."
  },
  "buttons": {
    "reviewTerms": "Review & Accept Terms",
    "requestCredit": "Request Credit"
  },
  "tooltips": {
    "unavailable": "Line of Credit is temporarily unavailable. Repayment continues as normal.",
    "frozen": "Your credit line is frozen (account closure in progress).",
    "closed": "Your credit line has been closed.",
    "noCredit": "No available credit remaining."
  },
  "progress": {
    "label": "Progress",
    "amount": "Amount",
    "status": "Status",
    "pendingApproval": "Pending Admin Approval"
  }
}
